import { createSelector } from 'reselect';
import { get } from '../../lib/nodash';

const selectReferralCode = createSelector(
  (state) => state.industry,
  (industry) => get('member.referral_code', industry)
);

export default selectReferralCode;
